import { Card, Typography, Chip, Stack } from "@mui/material";
import { Box } from "@mui/system";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";

// ─────────────────────────────────────────────────────────────────────────────

type StatusColor = "success" | "error";

interface NoPlayerCardProps {
  website_name: string;
  website_id: string;
  totalIncome: string;
  cpa: string;
  cpaPercentage: string;
  cpaColor: StatusColor;
  rs: string;
  rsPercentage: string;
  rsColor: StatusColor;
  reg: string;
  click_out: string;

  ftd: string;
  ftd_status: string;
  ftd_percentage: string;
  qftd: string;
  qftd_status: string;
  qftd_percentage: string;
  ftd_incent_percentage: string;
  qftd_incent_percentage: string;
  ftd_incent_status: string;
  qftd_incent_status: string;
  brand_action_date: string;
}

export function NoPlayerCard({
  website_name,
  website_id,
  totalIncome,
  ftd,
  ftd_status,
  qftd,
  brand_action_date,
}: NoPlayerCardProps) {
  return (
    <>
      <Card
        sx={{
          p: 1,
          borderRadius: spacing.Radius.lg.$value,
          boxShadow: "0px 1px 2px #0A0D120F , 0px 1px 3px #0A0D121A",
          border: "1px solid" + colors.GrayLightMode[200].$value,
          mb: spacing.Spacing.none.$value,
          mt: spacing.Spacing.xl.$value + "!important",
        }}
      >
        {/* Top Row */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="body1"
            sx={{
              color: colors.GrayLightMode[700].$value,
              fontSize: typography.Size.Text.xs.$value,
              fontWeight: typography.Font_weight.Medium.$value,
              mb: spacing.Spacing.md.$value,
            }}
          >
            {website_name} ({website_id})
          </Typography>
        </Stack>

        <Stack
          sx={{
            justifyContent: "space-between",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[900].$value,
            }}
          >
            Gap in Players Reporting
          </Typography>
          <Chip
            label={totalIncome}
            size="medium"
            sx={{
              borderRadius: spacing.Radius.xs.$value,
              fontSize: typography.Size.Text.md.$value,
              bgcolor:
                ftd_status === "success"
                  ? colors.Success[50].$value
                  : ftd_status === "warning"
                    ? colors.Warning[50].$value
                    : colors.Error[50].$value,

              color:
                ftd_status === "success"
                  ? colors.Success[600].$value
                  : ftd_status === "warning"
                    ? colors.Warning[600].$value
                    : colors.Error[600].$value,

              fontWeight: typography.Font_weight.Semibold.$value,
            }}
          />
        </Stack>

        <Stack>
          <Typography
            variant="body1"
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[900].$value,
              mb: spacing.Spacing.sm.$value,
            }}
          >
            Brand Action Date:
            <Box
              component="span"
              sx={{
                fontSize: typography.Size.Text.sm.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                ml: spacing.Spacing.xs.$value,
              }}
            >
              {brand_action_date}
            </Box>
          </Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          mt={spacing.Spacing.xs.$value}
          mb={spacing.Spacing.md.$value}
        >
          <Box
            sx={{
              width: "50%",
              borderRight: "1px solid" + colors.GrayLightMode[200].$value,
              pr: spacing.Spacing.md.$value,
            }}
          >
            <Typography
              mb={spacing.Spacing.xs.$value}
              sx={{
                color: colors.GrayLightMode[500].$value,
                fontSize: typography.Size.Text.xs.$value,
              }}
            >
              FTD’s in Player Report
            </Typography>
            <Box>
              <Typography
                sx={{
                  color: colors.GrayLightMode[900].$value,
                  fontSize: typography.Size.Text.md.$value,
                  fontWeight: typography.Font_weight.Semibold.$value,
                  pr: spacing.Spacing.xs.$value,
                }}
              >
                {ftd}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              width: "50%",
              pl: spacing.Spacing.md.$value,
            }}
          >
            <Typography
              mb={spacing.Spacing.xs.$value}
              sx={{
                color: colors.GrayLightMode[500].$value,
                fontSize: typography.Size.Text.xs.$value,
              }}
            >
              FTD’s in Daily Report
            </Typography>
            <Box>
              <Typography
                sx={{
                  color: colors.GrayLightMode[900].$value,
                  fontSize: typography.Size.Text.md.$value,
                  fontWeight: typography.Font_weight.Semibold.$value,
                  pr: spacing.Spacing.xs.$value,
                }}
              >
                {qftd}
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Card>
    </>
  );
}
export default NoPlayerCard;
